import { IControl } from "Controls/Interfaces";
import { ServiceProvider } from "Service";
import { ControlDefinition, Environment } from "Service/Client";

/**
 * Factory to create an instance of the control.
 * @hidden
 */
export type ControlFactory = (
    controlDefinition: ControlDefinition,
    textBlockCategory: string,
    serviceProvider: ServiceProvider,
    environment: Environment
) => IControl;

/**
 * Configuration for a ControlType.
 * @hidden
 */
export class ControlTypeConfiguration {
    private _controlFactory: ControlFactory;

    // get the factory for this control.
    public get controlFactory() {
        return this._controlFactory;
    }

    /**
     * Create a new Configuration.
     * @param controlFactory The factory for the control.
     */
    constructor(controlFactory: ControlFactory) {
        this._controlFactory = controlFactory;
    }
}
